import React from 'react';
import { Search, Package, Code, Users } from 'lucide-react';
import AnimateOnScroll from './ui/AnimateOnScroll';
import Lottie from 'lottie-react';
import serviceAnimation from '../assets/service-animation.json';

const services = [
  {
    id: 1,
    title: 'ייעוץ חד פעמי',
    description: 'פגישת ייעוץ ממוקדת לפתרון בעיות ספציפיות או לייעול תהליכים קיימים בעסק שלך.',
    icon: Search,
  },
  {
    id: 2,
    title: 'הטמעת מערכות מדף',
    description: 'בחירה והטמעה של פתרונות מוכנים המותאמים לצרכי העסק שלך, חיסכון בזמן ובמשאבים.',
    icon: Package,
  },
  {
    id: 3,
    title: 'פיתוח מערכות מותאמות אישית',
    description: 'פיתוח פתרונות טכנולוגיים ייחודיים המותאמים בדיוק לצרכים ולתהליכים הספציפיים בעסק שלך.',
    icon: Code,
  },
  {
    id: 4,
    title: 'סדנאות טכנולוגיה לעסקים',
    description: 'הדרכות וסדנאות מעשיות להכרת כלים טכנולוגיים והטמעתם בתהליכי העבודה היומיומיים.',
    icon: Users,
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-tech-gray relative overflow-hidden">
      <div className="absolute left-0 top-20 w-40 h-40 opacity-10 z-0">
        <Lottie animationData={serviceAnimation} loop={true} />
      </div>
      
      <div className="section-container relative z-10">
        <AnimateOnScroll animation="animate-fade-in">
          <h2 className="section-title text-tech-darkGray">הכלים להתייעלות שלך</h2>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
          {services.map((service, index) => (
            <AnimateOnScroll 
              key={service.id} 
              animation="animate-fade-in" 
              delay={index * 100}
              className="h-full"
            >
              <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all-300 h-full flex flex-col items-center text-center">
                <div className="w-20 h-20 bg-tech-lightBlue rounded-full flex items-center justify-center mb-5">
                  <service.icon className="w-10 h-10 text-tech-blue" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-tech-darkGray">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;